import { render, staticRenderFns } from "./ProfileChrome.vue?vue&type=template&id=018d46d2&"
import script from "./ProfileChrome.vue?vue&type=script&lang=js&"
export * from "./ProfileChrome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports